import React from 'react';
import { graphql, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import LoadingIndicator from 'components/LoadingIndicator';
import queryString from 'query-string';

import XPAY_MUTATION from './graphql/xpayMutation.gql';
import { reportConversionAnalytics } from './Helpers/actions';

class XpayRedirect extends React.PureComponent {
  componentDidMount() {
    const currentQuery = queryString.parse(this.props.location.search);
    console.log('currentQuery', currentQuery);

    const checkoutableType = currentQuery.member_id.split('-')[0];
    const checkoutableNumber = currentQuery.member_id.split('-')[1];

    if (currentQuery.transaction_status === 'SUCCESSFUL') {
      this.processXpayResponse(checkoutableType, checkoutableNumber);
    } else {
      this.props.history.replace(
        `/checkout/${checkoutableType}/${checkoutableNumber}`
      );
    }
  }

  processXpayResponse = async (checkoutableType, checkoutableNumber) => {
    const result = await this.props.processXpayResponse({
      variables: { query_string: this.props.location.search },
    });

    if (result.data.processXpayResponse && result.data.processXpayResponse.id) {
      if (result.data.processXpayResponse.report_to_analytics) {
        reportConversionAnalytics(
          'CreditCard',
          checkoutableNumber,
          result.data.processXpayResponse.info.total_usd
        );
      }

      this.props.history.replace(`/checkout/${checkoutableType}/thank_you`, {
        paymentMethod: {
          type: 'CreditCard',
          total: result.data.processXpayResponse.total,
          totals: { due: result.data.processXpayResponse.total },
          currencyCode: result.data.processXpayResponse.currency.code,
        },
        checkoutableType,
        checkoutableNumber,
      });
    } else {
      this.props.history.replace(
        `/checkout/${checkoutableType}/${checkoutableNumber}`
      );
    }
  };

  render() {
    return <LoadingIndicator />;
  }
}

export default compose(
  withRouter,
  graphql(XPAY_MUTATION, { name: 'processXpayResponse' })
)(XpayRedirect);



// WEBPACK FOOTER //
// ./app/containers/Checkout/XpayRedirect.js